import { cn } from '@/lib/utils';

/**
 * The Your Desk mark — a small rising-sun burst over a horizon line.
 * Warm, a little whimsical, and used across Desk Welcome, Desk Setup
 * and Your Next Move so the whole system reads as one place.
 */
export default function DeskMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 48 32"
      fill="none"
      aria-hidden
      className={cn('h-8 w-12', className)}
    >
      {/* rays */}
      <g stroke="hsl(var(--brand-soft))" strokeWidth="2" strokeLinecap="round">
        <line x1="24" y1="4" x2="24" y2="9" />
        <line x1="12" y1="8" x2="15" y2="12" />
        <line x1="36" y1="8" x2="33" y2="12" />
        <line x1="5" y1="18" x2="10" y2="19.5" />
        <line x1="43" y1="18" x2="38" y2="19.5" />
      </g>
      {/* sun */}
      <path
        d="M14 24a10 10 0 0 1 20 0"
        fill="hsl(var(--brand-soft) / 0.25)"
        stroke="hsl(var(--brand))"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* horizon / desk line */}
      <line
        x1="4"
        y1="24"
        x2="44"
        y2="24"
        stroke="hsl(var(--brand))"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="12"
        y1="29"
        x2="36"
        y2="29"
        stroke="hsl(var(--desk-paper-edge))"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
